import moment from 'moment'
import React, { Component } from 'react'

export default class MobCopyright extends Component {
  navigation = val => {
    if (val === 'linkedin') {
      window.open('https://www.linkedin.com/company/universal-health-fellowship/')
    }
    if (val === 'facebook') {
      window.open('https://www.facebook.com/universalhealthshare/')
    }
    if (val === 'instagram') {
      window.open('https://www.instagram.com/universalhealthfellowship/')
    }
  }
  render() {
    return <div  className="fixed-bottom" style={{  backgroundColor: '#E4EFFC', bottom: '0', left: 0, right: 0, position: 'static', zIndex:100, width:'100vw'}}>
    <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingBottom: '70px'}}>
      <div>
        <p className="fontStyles footerIcons" style={{ fontSize: '11px', color: '#333333', textAlign:'center' }}>
          Copyright © {moment().format("YYYY")} Universal Health Fellowship. All rights reserved. | Powered by CarynHealth <br />
          Version 5.1.0
        </p>
      </div>
      <div className="fontStyles footerIcons">
        <SocialIcon icon={'LinkedIn icon.svg'} onClick={() => this.navigation('linkedin')} />
        <SocialIcon icon={'Facebook icon.svg'} onClick={() => this.navigation('facebook')} />
        <SocialIcon icon={'Instagram icon.svg'} onClick={() => this.navigation('instagram')} />
      </div>
    </div>
  </div>
  }
}
const SocialIcon = ({ icon, onClick }) => {
  return <img width={35} src={require(`../Images/NewIcons/${icon}`)} style={{ marginRight: 10, marginTop:10, cursor: 'pointer', zIndex:1029 }} onClick={onClick} />
}